import { Button, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FloatingTextField from "../../components/formFields/floatingText/FloatingTextField";
import { Icon } from "../../components/icon/Icon";
import FormFieldValidation from "../../enums/FormFieldValidation";

interface IKeywordsProps {
    keywords: string[];
    isReadOnly: boolean;
    validation: FormFieldValidation;
    onKeywordsChanged: (keywords: string[]) => void;
}

export const Keywords = (props: IKeywordsProps) => {
    const { t } = useTranslation();
    const { keywords, isReadOnly, validation, onKeywordsChanged } = props;

    const handleKeywordAdded = () => onKeywordsChanged([...keywords, ""]);
    
    const handleKeywordUpdated = (index: number, value: string) => {
        const updatedKeywords = [...keywords];
        updatedKeywords[index] = value;
        onKeywordsChanged(updatedKeywords);
    };
    
    const handleKeywordRemoved = (index: number) => {
        const updatedKeywords = keywords.filter((_, i) => i !== index);
        onKeywordsChanged(updatedKeywords);
    };

    return (
        <Row className="mt-2">
            <Col>
                <Row>
                    <Col>
                        <h3 className="h4">
                            {t("dsar.form.sections.keywords.title")}
                        </h3>
                        <p className="text-muted small mb-0">
                            {t("dsar.form.sections.keywords.description")}
                        </p>
                        {
                            validation === FormFieldValidation.INVALID &&
                            <p className="text-danger small">
                                {t("dsar.form.sections.keywords.fields.keyword.validation")}
                            </p>
                        }
                    </Col>
                </Row>
                    {
                        keywords.map((keyword, index) => (
                            <Row key={index} className="mt-3 mb-2">
                                <Col>
                                    <FloatingTextField
                                        label={t("dsar.form.sections.keywords.fields.keyword.label", { number: index + 1 })}
                                        disabled={isReadOnly}
                                        onChange={value => handleKeywordUpdated(index, value)}
                                        validation={FormFieldValidation.NOT_VALIDATED}
                                        type="text"
                                        value={keyword}
                                        required={false}
                                        />
                                </Col>
                                <Col xs="auto">
                                    <OverlayTrigger placement="top" overlay={<Tooltip>{t("general.remove")}</Tooltip>}>
                                        <Button variant="outline-danger" onClick={() => handleKeywordRemoved(index)} disabled={isReadOnly} className="px-4 py-3">
                                            <Icon iconName="Trash" />
                                        </Button>
                                    </OverlayTrigger>
                                </Col>
                            </Row>
                        ))
                    }
                    
                    <Row className="mb-3">
                        <Col>
                            <Button variant="outline-primary" onClick={handleKeywordAdded} disabled={isReadOnly}>
                                <Icon iconName="Plus" endMargin={1} />
                                {t("general.add")}
                            </Button>
                        </Col>
                    </Row>
            </Col>
        </Row>
    );
};